var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.meta.hideHeader && !_vm.$route.meta.HBFHeader)?_c('Header'):_vm._e(),(_vm.$route.meta.HBFHeader)?_c('HeaderHBF'):_vm._e(),_c('div',{staticClass:"flex-wrapper"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('FooterHBF')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }